import { until, useStorage } from '@vueuse/core'
import { bonusPlaceApi, placeOrder as placeOrderApi, placeStopOrder } from '~/apis/future'
import { useFutureStore } from '~/store/future'
import { usePanelStore } from '~/store/panel'
import { div } from '#imports'
import { useUserStore } from '~/store/user'
import { accountsName } from '~/apis/socket'

export function usePanel() {
  const { t } = useI18n()
  const user = useUserStore()
  const panel = usePanelStore()
  const future = useFutureStore()
  const orderConfirm = useStorage('futureOrderConfirm', 0)

  const loading = ref(false)
  const unitName = computed(() => future.isLot ? t('张') : future.isLotBase ? future.base : future.quote)
  const unitText = computed(() => future.isLot ? t('张') : future.isLotBase ? t('数量') : future.isLotCost ? t('成本价值') : t('名义价值'))

  const OrderSubType = {
    DEFAULT: 0,
    LAST: 2,
    INDEX: 3,
    MARK: 4,
  }

  const placeOrder = async ({ side, orderSubType = OrderSubType.DEFAULT, code = future.code, id, price = '', reduceOnly, quantity, orderConditions, stopType, stopPrice, triggerDirection, accountType = future.accountType, orderConfirmType, bonusId, ignoreLoading = false }) => {
    if (loading.value) {
      return
    }
    const clientOrderId = Date.now()
    const accountName = accountsName[accountType]
    const { marginType, leverage } = future.getPositionConfigByCode(code, null, accountName)
    const marginRate = div(1, leverage).toFixed()
    const accountId = future.getAidByType(future.isGrants ? 10 : accountType)
    const payload = {
      accountType,
      accountId,
      contractId: id ?? future.getInfo(code).id ?? future.id,
      side,
      orderType: price ? 1 : 3,
      price,
      quantity,
      positionEffect: reduceOnly ? 2 : 1,
      marginType,
      marginRate,
      orderSubType,
    }
    if ([10, 30].includes(accountType)) {
      if (user.noAuth) {
        return (user.modal.kyc = true)
      }
      Object.assign(payload, {
        accountType,
        accountId,
      })
      if (!reduceOnly && accountType === 10) {
        Object.assign(payload, {
          bonusType: 8,
        })
      }
      if (accountType === 30) {
        Object.assign(payload, {
          bonusId,
          bonusType: 3,
          accountType: 10,
        })
      }
    }
    // stopType 0 条件单 1 仓位止盈止损 2预设止盈止损
    if (stopType === 0) {
      Object.assign(payload, {
        clientOrderId,
        orderSubType: OrderSubType[panel.stop.triggerPriceType],
        stopPrice: panel.stop.triggerPrice,
        triggerDirection: panel.triggerDirection,
        stopType,
      })
    }
    if (stopType === 1) {
      Object.assign(payload, {
        clientOrderId,
        stopPrice,
        triggerDirection,
        stopType,
      })
    }
    if (stopType === 2) {
      Object.assign(payload, {
        clientOrderId,
        orderConditions,
        stopType,
      })
    }
    if (orderConfirm.value) {
      future.modal.orderConfirm = true
      future.modalData.orderConfirm = { ...payload, orderConfirmType }
      console.log(future.modalData.orderConfirm)

      await until(() => future.modal.orderConfirm).toBe(false)
      if (Object.keys(future.modalData.orderConfirm).length) {
        return
      }
    }
    else if (!ignoreLoading) { // 仓位止盈止损不设置loading，否则无法同时下两单
      loading.value = true
    }
    const api = stopType > -1 ? placeStopOrder : [10, 30].includes(accountType) ? bonusPlaceApi : placeOrderApi
    const { success } = await api(payload)
    loading.value = false
    return success
  }

  return {
    unitName,
    unitText,
    OrderSubType,
    placeOrder,
  }
}
